import {
  QueryBuilderAstNodeType,
  QueryBuilderOperatorType,
  QueryBuilderTokenType,
} from '../../../../../../../types';
import { ParseResultType, QueryExpressionParserType } from '../../../types';
import { foldGroup } from './helpers';

export const parseOperatorChain = (
  tokens: QueryBuilderTokenType[],
  index: number,
  operator: QueryBuilderOperatorType,
  parseOperand: QueryExpressionParserType
): ParseResultType | null => {
  const firstNode = parseOperand(tokens, index);

  if (!firstNode) return null;

  const children: QueryBuilderAstNodeType[] = [firstNode.node];
  let currentIndex = firstNode.nextIndex;

  while (true) {
    const token = tokens[currentIndex];

    if (token?.type !== 'operator' || token.operator !== operator) {
      break;
    }

    currentIndex += 1;
    const nextNode = parseOperand(tokens, currentIndex);

    if (!nextNode) return null;

    children.push(nextNode.node);
    currentIndex = nextNode.nextIndex;
  }

  const node = foldGroup(operator, children);

  if (!node) return null;

  return {
    node,
    nextIndex: currentIndex,
  };
};
